import { getOrdersOrderIdCharges } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { OrderCharge } from "Order/Modules/Payment/Types/orderCharge";
import { useQuery } from "@tanstack/react-query";

export const getOrderChargeListQueryKey = (orderId: number) => [
	"ORDER_CHARGE_LIST",
	orderId,
];

export function useOrderChargeListQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderChargeListQueryKey(orderId),
		queryFn: processResponse(() =>
			getOrdersOrderIdCharges(orderId),
		) as () => Promise<OrderCharge[]>,
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId,
	});
}
